import { useState } from "react";

const testimonials = [
  {
    name: "Sarah M.",
    role: "Verified Buyer",
    location: "United States",
    text: "I've been shopping with HipoBuy 2026 for over a year now. The quality is absolutely amazing and shipping is always fast. The shoes I ordered look identical to the originals. Highly recommended to anyone looking for top-quality fashion!",
    avatar: "https://public.readdy.ai/ai/img_res/ad1138cd25299a093351caceb56ebc94.jpg",
    rating: 5,
    orders: 12,
  },
  {
    name: "James K.",
    role: "Regular Customer",
    location: "United Kingdom",
    text: "HipoBuy 2026 has the best selection of jerseys I've found anywhere online. The quality is top-notch and the prices are unbeatable. HipoBuy shipping was faster than expected. Will definitely order again!",
    avatar: "https://readdy.ai/api/search-image?query=young%20man%20portrait%20professional%20headshot%20clean%20background%20neutral%20tones&width=200&height=200&seq=tes002&orientation=squarish",
    rating: 5,
    orders: 8,
  },
  {
    name: "Emily R.",
    role: "Fashion Enthusiast",
    location: "Australia",
    text: "Found HipoBuy 2026 through a friend and I'm so glad I did. The hoodie collection is incredible — great quality fabric and perfect sizing. The customer service team was super helpful when I had questions.",
    avatar: "https://readdy.ai/api/search-image?query=woman%20portrait%20smiling%20professional%20headshot%20clean%20background%20warm%20tones&width=200&height=200&seq=tes003&orientation=squarish",
    rating: 5,
    orders: 15,
  },
  {
    name: "Michael T.",
    role: "Sneaker Collector",
    location: "Canada",
    text: "As a sneaker enthusiast, I was skeptical at first. But HipoBuy 2026 completely exceeded my expectations. The shoes are incredibly detailed and the quality is outstanding. Best purchase I've made this year!",
    avatar: "https://readdy.ai/api/search-image?query=man%20portrait%20smiling%20professional%20headshot%20clean%20background%20cool%20tones&width=200&height=200&seq=tes004&orientation=squarish",
    rating: 5,
    orders: 20,
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-3">
            <span className="h-px w-8 bg-amber-500"></span>
            <span className="text-amber-500 text-xs font-bold uppercase tracking-[0.2em]">Testimonials</span>
            <span className="h-px w-8 bg-amber-500"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            What Our Customers Say
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          {/* Left: avatar stack */}
          <div className="lg:col-span-2 flex flex-col items-center gap-4">
            <div className="relative w-64 h-64 md:w-80 md:h-80">
              {testimonials.map((item, i) => (
                <div
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`absolute rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 border-2 ${
                    i === current
                      ? "border-amber-500 z-20 scale-100 opacity-100"
                      : "border-transparent z-10 opacity-40 hover:opacity-70"
                  } ${
                    i === 0 ? "top-0 left-0 w-36 h-36 md:w-44 md:h-44" :
                    i === 1 ? "top-0 right-0 w-28 h-28 md:w-36 md:h-36" :
                    i === 2 ? "bottom-0 left-0 w-28 h-28 md:w-36 md:h-36" :
                    "bottom-0 right-0 w-36 h-36 md:w-44 md:h-44"
                  }`}
                >
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover object-top" />
                  {i === current && (
                    <div className="absolute bottom-2 left-2 right-2">
                      <div className="bg-amber-500 rounded-lg px-2 py-1 text-center">
                        <span className="text-white text-xs font-bold">{item.name}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="flex gap-6 mt-4">
              <div className="text-center">
                <div className="text-2xl font-black text-gray-900">{t.orders}+</div>
                <div className="text-gray-400 text-xs">Orders</div>
              </div>
              <div className="w-px bg-gray-100"></div>
              <div className="text-center">
                <div className="text-2xl font-black text-gray-900">5.0</div>
                <div className="text-gray-400 text-xs">Rating</div>
              </div>
              <div className="w-px bg-gray-100"></div>
              <div className="text-center">
                <div className="text-2xl font-black text-gray-900">100%</div>
                <div className="text-gray-400 text-xs">Satisfied</div>
              </div>
            </div>
          </div>

          {/* Right: review content */}
          <div className="lg:col-span-3 bg-stone-50 rounded-3xl p-8 md:p-10 relative overflow-hidden">
            {/* Decorative quote */}
            <div className="absolute top-6 right-8 text-8xl font-black text-stone-200 leading-none select-none">&ldquo;</div>

            <div className="relative z-10">
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center text-amber-400">
                    <i className="ri-star-fill"></i>
                  </div>
                ))}
              </div>

              <blockquote className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8 font-medium">
                &ldquo;{t.text}&rdquo;
              </blockquote>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-amber-500">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-black text-gray-900">{t.name}</p>
                  <p className="text-gray-500 text-sm">{t.role} · {t.location}</p>
                </div>
                <div className="ml-auto">
                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-green-500"></i>
                    </div>
                    Verified Purchase
                  </div>
                </div>
              </div>

              {/* Nav */}
              <div className="flex items-center gap-3 mt-8 pt-6 border-t border-stone-200">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`cursor-pointer transition-all duration-300 rounded-full ${i === current ? "w-8 h-2.5 bg-amber-500" : "w-2.5 h-2.5 bg-stone-300 hover:bg-stone-400"}`}
                  />
                ))}
                <div className="ml-auto flex gap-2">
                  <button
                    onClick={() => setCurrent((current - 1 + testimonials.length) % testimonials.length)}
                    className="w-9 h-9 flex items-center justify-center border border-stone-200 rounded-full hover:border-gray-400 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-left-line text-gray-600 text-sm"></i>
                  </button>
                  <button
                    onClick={() => setCurrent((current + 1) % testimonials.length)}
                    className="w-9 h-9 flex items-center justify-center bg-gray-900 rounded-full hover:bg-amber-500 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
